<template>
  <div class="diadin">
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item>
        <el-input style="width: 300px;" :placeholder="`${$t('menu.Title')}/${$t('menu.Code')}/${$t('menu.VehicleModel')}`"
          v-model="formInline.title"></el-input>
      </el-form-item>

      <!-- <el-form-item>
        <el-select v-model="formInline.category" placeholder="车型" @change="changeCheXing">
          <el-option v-for="item in list" :label="item.seriesModel" :value="item.id" :key="item.id"></el-option>
        </el-select>
      </el-form-item> -->

      <el-form-item>
        <el-button type="primary" @click="onSubmit">{{ $t('menu.search') }}</el-button>
      </el-form-item>
    </el-form>
    <div class="bonntbot">
      <el-tabs v-model="action" @tab-click="handleClick">
        <el-tab-pane v-for="(item, index) in mationlist" :key="index" :label="sxtitle(item)" :name="item.id + ''"
          v-if="item.visible == true"></el-tab-pane>


      </el-tabs>
      <div class="bonntbota">

      </div>

    </div>
    <div>
      <div v-for="(item, index) in mation" :key="index" class="list-item">
        <div class="right-item">
          <div style="display: flex;">
            <div class="left">
              <template>
                <el-image v-if="item.mainImageList" class="leftimg" :src="item.mainImageList"
                  :preview-src-list="item.mainImageList" @error="imgerror($event, index)">
                </el-image>

                <el-image v-else class="leftimg" :src="url">
                </el-image>
              </template>
              <div class="product-info">
                <div class="name-info">
                  <p style="color: #222222; text-decoration: underline;cursor: pointer;" @click="openDetails(item)">{{
                   inl8=='zh'? item.partName :item.partNameEn}}</p>
                  <p>{{ item.partNumber }}</p>
                  <p v-if="item.relationList.length > 0">{{ $t('menu.Alternative') }}：<span
                      v-for="(e, i) in item.relationList" :key="i">{{
                        e.relationPart.partNumber }}
                      <span v-if="i < item.relationList.length - 1">、</span> </span></p>
                  <!-- <div class="details">
                    {{ item.remarks }}
                  </div> -->
                  <div style="margin-top: 5px;" v-if="item.categoryId">{{ sxtitle(item.partCategory)}} </div>
                </div>
              </div>
            </div>

               <div class="price" v-if="bz == 'CNY'&&item.purchasePriceCny!==null&&pict==0">￥{{ item.purchasePriceCny }} <span class="pricea">{{
              pjst(item.unit)
            }}</span> </div>
            <div class="price" v-if="bz == 'USD'&&item.purchasePriceUsd!==null&&pict==0">${{ item.purchasePriceUsd }} <span class="pricea">{{
              pjst(item.unit)
            }}</span> </div>
            <div class="price" v-if="bz == 'EUR'&&item.purchasePriceEur!==null&&pict==0">€{{ item.purchasePriceEur }} <span class="pricea">{{
              pjst(item.unit)
            }}</span> </div>
             
            
                <div class="price" v-if="bz == 'CNY'&&item.purchasePriceCny!==null&&pict==1">￥{{    numFilter(item.purchasePriceCny/0.65) }} <span class="pricea">{{
              pjst(item.unit)
            }}</span> </div>
            <div class="price" v-if="bz == 'USD'&&item.purchasePriceUsd!==null&&pict==1">${{   numFilter(item.purchasePriceUsd/0.65) }} <span class="pricea">{{
              pjst(item.unit)
            }}</span> </div>
            <div class="price" v-if="bz == 'EUR'&&item.purchasePriceEur!==null&&pict==1">€{{   numFilter(item.purchasePriceEur/0.65) }} <span class="pricea">{{
              pjst(item.unit)
            }}</span> </div>
              
               
            
          </div>

          <div class="right" style="display: flex;flex: 1;align-items: baseline;">
            <div class="num-box">
              <el-input-number v-model="item.buyNum" :min="item.minPurchaseQuantity"
                @change="changeNum"></el-input-number>
              <!-- <p style="color: red;" v-if="item.minPurchaseQuantity == item.buyNum">最小采购量：{{ item.minPurchaseQuantity }}
              </p> -->
            </div>

            <div class="btn-box">
               <el-button type="primary" v-if="item.status == true&&tup=='2'&&item.partRetailer!==null" class="btn buy"
                    :disabled="item.partRetailer.status!==1"
                    :class="[item.btnType == true || item.status == false||item.partRetailer.status!==1 ? 'hui' : '']" @click="buyCart(item, index)">
                    <div style="display: flex; align-items: center; justify-content: center;"><img class="ico"
                        src="../../assets/images/PC20240924-103854.png" alt="">
                      <div class="jyyy">{{ item.btnType == true || item.status
                        ==
                        false ? $t('menu.Add') : $t('menu.Add') }}</div>
                    </div> 
                  </el-button>
                  <el-button type="primary" v-if="item.status == true&&tup=='2'&&item.partRetailer==null" class="btn buy hui"
                    disabled
                     @click="buyCart(item, index)">
                    <div style="display: flex; align-items: center; justify-content: center;"><img class="ico"
                        src="../../assets/images/PC20240924-103854.png" alt="">
                      <div class="jyyy">{{ item.btnType == true || item.status
                        ==
                        false ? $t('menu.Add') : $t('menu.Add') }}</div>
                    </div> 
                  </el-button>

              <el-button type="primary" v-if="item.status == true&&tup!=='2'" :disabled="item.btnType || item.status == false"
                :class="[item.btnType === true ? 'hui' : '', item.status == false ? 'hui' : '']" class="btn buy"
                @click="buyCart(item, index)">
                <div style="display: flex; align-items: center; justify-content: center;"><img class="ico"
                    src="../../assets/images/PC20240924-103854.png" alt="">
                  <div class="jyyy">{{ item.btnType == true || item.status
                    ==
                    false ?$t('menu.Add') :$t('menu.Add') }}</div>
                </div>
              </el-button>
              <el-button type="primary" v-if="item.status == false" :disabled="item.btnType || item.status == false"
                :class="[item.btnType === true ? 'hui' : '', item.status == false ? 'hui' : '']" class="btn buy"
                @click="buyCart(item, index)">
                <div style="display: flex; align-items: center; justify-content: center;">
                  <!-- <img class="ico"
                    src="../../assets/images/PC20240924-103854.png" alt=""> -->
                  <div class="jyyy">{{ item.btnType == true || item.status
                    ==
                    false ? $t('menu.Soldout') : $t('menu.Add') }}</div>
                </div>
              </el-button>
              <!-- <div class="btn end">已停供</div> <i class="el-icon-shopping-cart-1"></i>  -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bottompage">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage3"
        :page-sizes="[10, 20, 50, 100]" :page-size="10" layout="total,  prev, pager, next"
        :total="totale">
      </el-pagination>
    </div>


    <el-dialog :title="inl8=='zh'?detailsObj.partName:detailsObj.partNameEn" :visible.sync="detailsFlag" width="30%">
      <div class="details-box">
        <div class="text-box">
          <div>
            {{ $t('menu.unit') }}:{{ detailsObj.defaultPerVehicleUsage }}
          </div>

          <div>
            {{ $t('menu.Effectivedate') }}:{{ detailsObj.effectiveDate }}
          </div>

          <div>
            {{ $t('menu.MinimumPurchaseQuantity') }}:{{ detailsObj.minPurchaseQuantity }}
          </div>
        </div>

        <div class="shuoming">
          {{ detailsObj.remarks }}
        </div>

        <div class="img-box-details">
          <el-image class="elimg" v-for="(item,index) in detailsImgList" :key="index" :src="item" alt=""
            :preview-src-list="detailsImgList"></el-image>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { pageQueryPart, pageQueryPartCategory, addCart, listMcSeriesModels, querytype } from '../../api/api'

export default {
  data () {
    return {
      url: '',
      staue: [
        {
          name: this.$t('menu.All'),
          num: 0,

        },
        {
          name: '服务&维修',
          num: 0,
        },
        {
          name: '车体防护',
          num: 0,
        },
        {
          name: '车载储物',
          num: 0,
        },
        {
          name: '车载3C',
          num: 0,
        },
        {
          name: '服饰箱包',
          num: 0,
        },
        {
          name: '其他周边',
          num: 0,
        },
      ],
      inl8: 'zh',
      action: '',
      activeName: '0',
      currentPage3: 1,
      pagesize: 10,
      totale: 3,
      activeName: 'first',
      mation: [], //列表
      formInline: {
        title: '',
        startTime: '',
        endTime: '',
        contact: '',
        category: '',
        type: '',
      },
      list: [],
      mationlist: [],
      bz: 'CNY',
      prList: [],
      detailsFlag: false,
      detailsObj: {},
      detailsImgList: [],
      tup:1,
      pict:0,
    }
  },
  created () {
    let aa = sessionStorage.getItem('i18n')
    this.tup = sessionStorage.getItem('platform')
    this.inl8 = aa
    this.flbiao()
    this.biao()
     this.pict=sessionStorage.getItem('picaetype')||0
    this.bz = sessionStorage.getItem('shbz')
    this.jg()
    this.listMcSeriesModel()
    let a = sessionStorage.getItem('i18n')
    if (a == 'en') {
      this.url = require('../../assets/images/mrimg2.jpg')
    } else {
      this.url = require('../../assets/images/mrimg1.png')
    }


  },
  methods: {
      numFilter (value) {
          let realVal = ''
        if(value!==undefined&&value!==null&&value!==''){
         realVal = Number(value).toFixed(2)
        }
    // 截取当前数据到小数点后两位
  
    return realVal
  },
    sxtitle(e){
      let a =''
        console.log(11,e);
        
      if(this.inl8=='zh'){
        a=e.categoryName
      }
    if(this.inl8=='en'){
      if(e.categoryNameEn.indexOf(":") !== -1){
       
        let c =JSON.parse(e.categoryNameEn)
     
        a=c.en
      }else{
        a=e.categoryNameEn
      }
      

      }
      if(this.inl8=='de'){
         if(e.categoryNameEn.indexOf(":") !== -1){
             let d =JSON.parse(e.categoryNameEn)
        a=d.de
         } else{
        a=e.categoryNameEn
      } 
         
      
      }
      return a

    },
    imgerror (e, index) {
      console.log(1);

      // this.mation.mainImageList.splice(index, 1)
      // this.mation.mainImageList.splice(index, 0, '../../assets/images/mrimg1.png')
    },
    openDetails (item) {
      console.log(item)
      this.detailsImgList = []
      this.detailsObj = item
      if (this.detailsObj.detailImageList !== null) {
        let a =this.detailsObj.detailImageList.split(',')
        this.detailsImgList = a
      }
      this.detailsFlag = true
    },
    jg () {
      let param = new URLSearchParams();
      querytype(param, 't_part_unit').then(r => {
        if (r.data.code == 200) {
          this.prList = r.data.data
        }
      })
    },
    pjst (e) {
      let a = this.prList
      let b = ''
      a.forEach(z => {
        if (e == z.dictValue&&this.inl8=='zh') {
          b = z.dictLabel

        }
        if (e == z.dictValue&&this.inl8!=='zh') {
          b = z.dictLabelEn

        }
      })
      return '/' + b
    },
    handleClick (tab, event) {
      console.log(tab)
      this.action = tab.name
      console.log(this.action);
      this.currentPage3 = 1
      this.biao()

    },
    mationliststu (e) {
      let a = ''
      this.mationlist.forEach(z => {
        if (z.id == e &&this.inl8=='zh') {
          console.log(223,z);
           a = this.sxtitle(z)
        }
        // if (z.id == e &&this.inl8!=='zh') {
        //   a = z.categoryNameEn
        // }
      })
      return a
    },
    //获取车型
    async listMcSeriesModel () {
      let param = new URLSearchParams();

      const { data: res } = await listMcSeriesModels(param);

      this.list = res.data;
      this.formInline.category = this.mcSeriesModelId
      this.seriesModel = this.list[0].seriesModel;
    },
    changeNum () {
      this.$forceUpdate()
    },
    buyCart (item, index) {
      this.mation[index].btnType = true
      let param = new URLSearchParams()
      console.log(1111, this.mation[index])
      this.$forceUpdate()
      addCart(param, item.id, item.buyNum,9000).then((r) => {
        if (r.data.code == 200) {
          this.$message({
              message: this.$t('menu.SUCESS'),
          type: 'success',
          duration:1000,
          }
            
          )
          setTimeout(() => {
            this.mation[index].btnType = false
            this.$forceUpdate()
          }, 1000);
        } else {
          this.$message.error(r.data.msg)
          setTimeout(() => {
            this.mation[index].btnType = false
            this.$forceUpdate()
          }, 1000);


        }
      })
    },
    changeCheXing (e) {
      this.mcSeriesModelId = e
      this.list.forEach(i => {
        if (i.id === e) {
          this.seriesModel = i.seriesModel
        }
      })
      this.biao()
    },
    async flbiao () {
      let param = new URLSearchParams()

      let searchKey = ''
      let categoryId = ''
      const { data: res } = await pageQueryPartCategory(
        param,
        1,
        this.pagesize,
        '9000',
        searchKey,

      )


      this.mationlist = [
        {
          categoryName: this.$t('menu.All'),
          id: '',
          categoryNameEn:this.$t('menu.All'),
          visible: true
        }
      ]
      res.data.list.forEach(e => {
        this.mationlist.push(e)
      })
    },
    async biao () {
      // this.flbiao()
      let param = new URLSearchParams()
      if (this.action == 0) {
        this.action = ''
      }
      let searchKey = this.formInline.title
      let categoryId = this.action
      const { data: res } = await pageQueryPart(
        param,
        this.currentPage3,
        this.pagesize,
        '9000&order=status desc',
        searchKey,
        categoryId
      )

      this.mation = res.data.list

      res.data.list.forEach((e, i) => {
        this.mation[i].buyNum = e.minPurchaseQuantity
        this.mation[i].btnType = false
      })
      this.totale = res.data.total
    },

    //tab切换
    tabclick (i) {
      this.action = i
      this.currentPage3 = 1
      this.biao()
    },

    //搜索
    onSubmit () {
      this.currentPage3 = 1
      this.biao()
    },

    handleSizeChange (val) {
      this.pageSize = val
      console.log(`每页 ${val} 条`)
      this.biao()
    },
    handleCurrentChange (val) {
      this.currentPage3 = val
      this.biao()
    },
  },
}
</script>

<style lang="less" scoped>
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.list-item:hover {
  background-color: #40a0ff27;
}

.diadin {
  width: 100%;
  min-height: 80vh;
  background-color: #fff;
  padding: 20px;
  padding-left: 0;
}

.bonntbot {
  padding-bottom: 10px;



}

.bottompage {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
}

.right-item {
  position: relative;
  display: flex;
  padding-top: 10px;
  align-items: center;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
  // margin-bottom: 10px;

  .price {
    color: red;
    margin-left: 150px;
    display: flex;
    align-items: center;
  }
}

.leftimg {
  width: 150px;
  height: 120px;
  min-width: 150px;
 
}

.price {
  color: red;
  margin-left: 50px;
  display: flex;
  font-size: 18px;
  font-weight: 600;
  align-items: center;
}

.pricea {
  font-size: 14px;
  font-weight: 400;
  display: inline-block;
  color: #999999;
}

.right {
  position: absolute;
  right: -10%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
}

.num-box {
  height: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 70px;

  p {
    margin-top: 10px;
  }
}

.btn-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 30px;

  .btn {
    width: 180px;

    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    cursor: pointer;
  }

  .buy {
    background-color: #409eff;
  }

  .end {
    background-color: #d7d7d7;
  }
}
/deep/.el-dialog__header{
  padding-right: 80px;
}
/deep/.el-dialog__title{
  word-wrap: break-word;
    word-break: break-all;
    overflow: hidden;
    margin-right: 20px;
}
.product-info {
  margin-left: 20px;
  display: flex;
  color: #999999;

  .name-info {
    p {
      margin-bottom: 10px;
    }
  }
}

/deep/.el-table {
  min-height: 750px !important;
}

/deep/.el-table__body td {
  padding: 20px !important;
  text-align: center;
}

/deep/.el-table th.is-leaf {
  text-align: center;
  background-color: #d7d7d7;
}

/deep/.el-tabs {
  height: 97%;
  width: 100%;
}

.left {
  display: flex;
  width: 500px;
  margin-left: 10px;
}

.jyyy {
  font-size: 16px;
  padding-left: 8px;
}

/deep/.el-tabs__content {
  width: 100%;
  height: 100%;
}

/deep/.el-table--scrollable-x .el-table__body-wrapper {
  height: 90%;
}

/deep/.el-tab-pane {
  height: 82%;
}

/deep/.el-table--fit {
  height: 94%;
}

.xz-box {
  width: 400px;
  margin: 0 auto;
}

.actio {
  color: #409eff;
}

.hui {
  background-color: #d7d7d7 !important;
  border: none !important;
}

.ico {
  width: 20px;
  height: 20px;
}

.text-box {
  display: flex;
  flex-wrap: wrap;

  div {
    width: 50%;
    margin-bottom: 20px;
  }
}

.shuoming {}

.details-box {
  padding: 20px 0px;
  padding-top: 0;
}

.img-box-details {
  margin-top: 30px;
  display: flex;
  flex-wrap: wrap;
  width: 100%;

  .elimg {
    width: 100%;
   
    margin-right: 10px;
  }
}
</style>
